<template>
  <div class="container-finance-daly">
    <van-nav-bar
      id='van-nav-bar'
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    >
      <div slot="title" class="nav-bar-title">{{searchDay}}</div>
    </van-nav-bar>
    <div class="data-wrapper">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <FinanceItemDaly 
          v-for="item in list"
          :key="item.id"
          :payType = "item.bizType"
          :orderSn = "item.ordersn"
          :date = "item.createDate"
          :amount = "item.amount"
          :operationType = 'item.operationType'
          :status = "item.status"
        />
        </van-list>
    </div>
  </div>
</template>
<script>
import { getDayFinanceList } from "../../utils/api";
import FinanceItemDaly from "@/components/FinanceItemDaly.vue";
import { app } from "../../utils/app";
import { NavBar, Uploader, Popup, Form, Field, Button, List } from "vant";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(NavBar);
Vue.use(Vuex);
Vue.use(Uploader);
Vue.use(Popup);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(List);
// @ is an alias to /src

export default {
  name: "ShopData",
  components: {FinanceItemDaly},
  data() {
    return {
      list:[],
      searchDay:'',
      loading:false,
      finished:false,
      limit:20,
      offset:0
    };
  },
  created() {
    let query = this.$route.query.date
    this.searchDay = query
    let shopToken = app.storage.get("shopToken");
    this.shopToken = shopToken;
    console.log("shopToken:", this.shopToken);
    // this.getDayFinanceList();
  },
  mounted() {

  },
  watch: {},
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    async getDayFinanceList() {
      let params = {
        limit:this.limit,
        offset:this.offset,
        searchDay: this.searchDay,
        usertoken: this.shopToken,
      };
      let res = await getDayFinanceList(params);
      if (res.data.code == 0) {
        if (res.data.balanceInfoList&&res.data.balanceInfoList.length != 0) {
          let newList = this.list.concat(res.data.balanceInfoList)
          this.list = newList
          this.loading = false
          this.offset = this.offset + this.limit
        }else{
          this.finished = true
        }
      }
    },
    onLoad(){
      this.getDayFinanceList();
      this.loading = true
    }
  },
};
</script>
<style lang="scss">

</style>
